import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "I used to spend my first 90 minutes just clearing inboxes. ClearMakes does it before I wake up. It's not a tool; it's an Executive Assistant.",
    label: "Founder / CEO",
  },
  {
    quote:
      "The 'Priority Hub' ensures I never miss a high-ticket lead in the message noise. My response time dropped by 50%.",
    label: "VP of Sales",
  },
  {
    quote:
      "The Calendar Sync is magic. A client texts a time, I click one button, and the invite is sent. No more tab switching.",
    label: "Operations Manager",
  },
];

export const SocialProofSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 noise-texture" />
      <div className="absolute inset-0 bg-[#0A0F1C]/50" />
      <div className="container relative z-10" ref={ref}>
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="heading-lg mb-4">Built for Power Users.</h2>
          <p className="body-lg max-w-xl mx-auto text-muted-foreground">
            Trusted by executives, sales leaders, and operations teams.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              className="glass-panel p-8 rounded-2xl border border-white/10"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <Quote className="w-10 h-10 text-primary/40 mb-4" />
              <p className="text-foreground/90 mb-6 leading-relaxed">&quot;{t.quote}&quot;</p>
              <p className="text-xs font-medium text-primary">{t.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
